<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <div role="status" :aria-label="t('CONVERSATION.LOADING_CONVERSATIONS')">
    <div class="space-y-1 p-1 motion-safe:animate-pulse" aria-hidden="true">
      <div
        v-for="row in 10"
        :key="row"
        class="flex gap-2 rounded-xl px-2 py-3"
        :class="row === 1 ? 'bg-n-alpha-1' : ''"
      >
        <div class="size-8 shrink-0 rounded-full bg-n-alpha-2" />
        <div class="min-w-0 flex-1 space-y-3">
          <div class="flex items-center justify-between gap-4">
            <div
              class="h-3 rounded bg-n-alpha-2"
              :class="row % 2 ? 'w-28' : 'w-20'"
            />
            <div class="h-2 w-8 shrink-0 rounded bg-n-alpha-2" />
          </div>
          <div class="h-2.5 w-full rounded bg-n-alpha-2" />
          <div class="flex items-center justify-between">
            <div class="h-2 w-2/5 rounded bg-n-alpha-2" />
            <div class="size-4 rounded-full bg-n-alpha-2" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
